var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 sm:px-6 mx-2"},[_c('BaseCard',{staticClass:"space-y-4"},[_c('retur-header',{attrs:{"to":{
        name: 'create.retur.pelayanan',
      }},on:{"search":_vm.onSearch},model:{value:(_vm.filter.search),callback:function ($$v) {_vm.$set(_vm.filter, "search", $$v)},expression:"filter.search"}}),_c('retur-table',{on:{"page-change":_vm.onPageChange,"click-row":_vm.onDetail}})],1),(_vm.isLoadingRetur)?_c('loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }